export default __webpack_public_path__ + "static/media/pg-34.2aeebdc5.jpg";